import { useAnalytics } from "@codat/analytics";
import { PaginationRange as OrchardPaginationRange } from "@codat/orchard-ui";
import { PaginationRangeProps as OrchardPaginationRangeProps } from "@codat/orchard-ui/dist/es/components/PaginationRange";
import React from "react";

interface PaginationRangeProps extends OrchardPaginationRangeProps {
  className?: string;
  eventProperties?: Record<string, unknown>;
}

export const PaginationRange: React.FC<PaginationRangeProps> = (props) => {
  const { eventProperties, onUpdatePageIndex, ...paginationRangeProps } = props;
  const { sendEvent } = useAnalytics();

  const handleOnUpdatePageIndexWithTracking = (newPageIndex: number) => {
    if (onUpdatePageIndex) {
      onUpdatePageIndex(newPageIndex);
    }
    sendEvent("Pagination - Page index - Click", {
      ...eventProperties,
      newPageIndex,
    });
  };

  return (
    <OrchardPaginationRange
      {...paginationRangeProps}
      onUpdatePageIndex={handleOnUpdatePageIndexWithTracking}
    />
  );
};
